import { t } from '@lingui/macro'

const minute = 60000
const hour = 60 * minute
const day = 24 * hour
const week = 7 * day
const month = 30 * day
const year = 365 * day

// todo - move to a useEffects based hook to prevent usage on server
// note - do not use on server (translations will not appear)
export const getRelativeTime = (time: number) => {
  const diff = Date.now() - time
  if (diff < 0) {
    return t`right now`
  } else if (diff < minute) {
    return t`a minute ago`
  } else if (diff < hour) {
    const minutes = Math.floor(diff / minute)
    return t`${minutes} minutes ago`
  } else if (diff < day) {
    const hours = Math.floor(diff / hour)
    return t`${hours} hours ago`
  } else if (diff < week) {
    const days = Math.floor(diff / day)
    return t`${days} days ago`
  } else if (diff < month) {
    const weeks = Math.floor(diff / week)
    return t`${weeks} weeks ago`
  } else if (diff < year) {
    const months = Math.floor(diff / month)
    return t`${months} months ago`
  }
  return t`more than a year ago`
}
